import { render, staticRenderFns } from "./TraceabilityTable.vue?vue&type=template&id=9182af90&scoped=true"
import script from "./TraceabilityTable.vue?vue&type=script&lang=js"
export * from "./TraceabilityTable.vue?vue&type=script&lang=js"
import style0 from "./TraceabilityTable.vue?vue&type=style&index=0&id=9182af90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9182af90",
  null
  
)

export default component.exports